import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autosuggest from 'react-autosuggest';
import { selectAllPos, clearPosList, posApi } from "../../reducers/posSlice";

const PosAutosuggest = ({pos, onItemSelected, readOnly}) => {
    const [value, setValue] = useState(pos ? pos.company_name : "")
    const items = useSelector( (state) => selectAllPos(state) );
    const [forceSuggestion, setForceSuggestion] = useState(false);

    const dispatch = useDispatch();
    let sorting = {
        id: null,
        code: null,
        company_name: 'ASC',
        sign: null,
        group: null,
        type: null,
        address: null,
        state: null,
        avg_score: null,
    }

    useEffect(()=>{
        if(readOnly) {
            setValue("")
            setForceSuggestion(false)
        }
    }, [readOnly])

    const renderSuggestion = (suggestion) => (
        <div>
          {suggestion.company_name}
        </div>
    );

    const onChange = (event, { newValue, method }) => {
        setValue(newValue);
        if(onItemSelected) onItemSelected(null)
    };

    const suggestionOptions = {
        value: value,
        onChange: onChange,
        onKeyDown: ((event) => {
            if(event.keyCode === 40 && value === "") {
                dispatch( posApi.fetchAll({page: 0, term: "", sorting: sorting}) );
                setForceSuggestion(true)
            } else {
                setForceSuggestion(false)
            }
        }),
        onDoubleClick: ((event) => {
            if(!readOnly) {
                dispatch( posApi.fetchAll({page: 0, term: value, sorting: sorting}) );
                setForceSuggestion(true)
            }
        }),
        className: "form-control",
        placeholder: 'Inserisci la ragione sociale del PdV',
        readOnly: readOnly
    }

    const containerProps = {
        // style: {position: 'absolute'}
    };

    const getSuggestionValue = (suggestion) => { 
        return suggestion.company_name
    };

    const onSuggestionsFetchRequested = (value ) => {
        setForceSuggestion(false)
        dispatch( posApi.fetchAll({page: 0, term: value, sorting: sorting}) );
    };

    const onSuggestionsClearRequested = () => {
        setForceSuggestion(false)
        dispatch ( clearPosList() );
    };

    const onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        if(onItemSelected) onItemSelected(suggestion)
        dispatch ( clearPosList() );
    }

    const shouldRenderSuggestions = (value, reason) => {
        return (forceSuggestion || value.length > 0) && !readOnly
    }


    return (
        <Autosuggest 
            id={"pos_autosuggest"}
            shouldRenderSuggestions={shouldRenderSuggestions}
            suggestions={items}
            onSuggestionsFetchRequested={({value}) => { onSuggestionsFetchRequested(value) }}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            onSuggestionSelected={onSuggestionSelected}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={suggestionOptions}
            containerProps={containerProps}
        />
    )
}

export default PosAutosuggest;